import ContainerStore from './container';

// Shoppinglist Store
export default class ShoppinglistStore extends ContainerStore {}
